<template>
  <UiCard>
    <div slot="title">
      <span class="title">{{ domain }}</span>
    </div>
    <div v-if="canEditApplications" slot="more">
      <disableAccount />
    </div>

    <UiCardContentLine class="card_content_line">
      <span slot="title">Баланс</span>
      <span slot="value">{{ balance }}</span>
    </UiCardContentLine>

    <div slot="content">
      <UiCardContentLine class="card_content_line">
        <span slot="title">Баланс</span>
        <span slot="value">{{ balance }}</span>
      </UiCardContentLine>

      <UiCardContentLine class="card_content_line">
        <span slot="title">Бонусные баллы</span>
        <span slot="value">{{ bonus }}</span>
      </UiCardContentLine>

      <UiCardContentLine class="card_content_line">
        <span slot="title">Разрешить активацию Google Pay</span>
        <div slot="value" class="actions-value-wrapper">
          <enableGpayActivation />
        </div>
      </UiCardContentLine>

      <UiCardContentLine class="card_content_line">
        <span slot="title">Google Pay</span>
        <div slot="value" class="actions-value-wrapper">
          <blockGpay />
        </div>
      </UiCardContentLine>
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiCardContentLine from '@/components/card/UiCardContentLine.vue'
import blockGpay from './BlockGpay.vue'
import enableGpayActivation from './EnableGpayActivation.vue'
import disableAccount from './DisableAccount.vue'

import currentApplicationMixin from '../mixins/currentApplicationMixin'
import currentUser from '@/mixins/currentUser';
import { currecyFormat } from '@/mixins/currency'

import { mapGetters } from 'vuex'

export default {
  components: { UiCard, UiCardContentLine, blockGpay, enableGpayActivation, disableAccount },
  mixins: [currentApplicationMixin, currentUser],
  computed: {
    ...mapGetters({
      abilities: 'user/definedAbilities',
    }),
    domain() {
      return this.$currentApp && this.$currentApp.domain
    },
    canEditApplications() {
      return this.abilities.can('edit', 'applications')
    },
    balance() {
      if (!this.$currentApp) return

      return currecyFormat(this.$currentApp.balance, { style: 'currency' })
    },
    bonus() {
      if (!this.$currentApp) return

      return this.$currentApp.balanceBonus
    },
  },
}
</script>
